import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown, DropdownInputProps } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS: DropdownInputProps['options'] = [
  {
    value: '',
    label: 'Не закрывать регистрацию',
  },
  {
    value: 5,
    label: 'За 5 минут до начала',
  },
  {
    value: 10,
    label: 'За 10 минут до начала',
  },
  {
    value: 15,
    label: 'За 15 минут до начала',
  },
  {
    value: 30,
    label: 'За 30 минут до начала',
  },
  {
    value: 60,
    label: 'За 1 час до начала',
  },
  {
    value: 2 * 60,
    label: 'За 2 часа до начала',
  },
  {
    value: 3 * 60,
    label: 'За 3 часа до начала',
  },
  {
    value: 12 * 60,
    label: 'За 12 часов до начала',
  },
  {
    value: 1 * 24 * 60,
    label: 'За 1 день до начала',
  },
];
export function RegistrationCutoffInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Закрыть регистрацию</FormLabel>

      <FormInput>
        <Controller
          name="registrationClosedBeforeStartMinutes"
          control={control}
          defaultValue={null}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value ? parseInt(value, 10) : null);
            };
            return (
              <Dropdown
                options={OPTIONS}
                value={value?.toString()}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
